import React, { useEffect, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";

import { useMutation, useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../../constants/api";
import useAuthAxios from "../../../utils/baseAxios";
import { errorMessage } from "../../../utils/errorMessage";
import ClipLoader from "react-spinners/ClipLoader";
import { formatAmount } from "../../../utils/formatTime";
import PortionAmount from "../../../components/PortionAmount";
import { BiMessageSquareAdd } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../context/user-context";
import { RiArrowDropDownFill } from "react-icons/ri";
import OtpPin from "../../../components/OtpPin";

const RedeemModal = ({ setRedeemModal }: any) => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState(false);
  const [amount, setAmount] = useState<string>("");
  const { userDetails, refetch } = useUser();
  const axiosInstance = useAuthAxios();
  const navigate = useNavigate();
  const [openBank, setOpenBank] = useState<boolean>(false);
  const [bankName, setBankName] = useState<string>("");
  const [bankNumber, setBankNumber] = useState<string>("");
  const [addPin, setAddPin] = useState<boolean>(false);
  const [otp, setOtp] = useState<string>("");
  const [bankId, setBankId] = useState<string>("");
  const [bankCode, setBankCode] = useState<string>("");
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);

  const isNumber = (str: any) => {
    if (str.trim() === "") {
      return false;
    }

    return !isNaN(str);
  };

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNumber(value)) {
      setAmount(value);
    } else {
      setAmount("");
    }
  };
  const getPoint = async () => {
    const response = await axiosInstance.get(API.getPointsBalance);
    return response.data;
  };
  const { data: point, error: error1 } = useQuery({
    queryKey: ["get-point"],
    queryFn: getPoint,
    retry: 1,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1]);
  const pointBalance = point?.data?.totalPoints;

  const redeemPoints = async (data: any) => {
    const response = await axiosInstance.post(API.redeemPoints, data);
    return response.data;
  };
  const completeRedeem = useMutation({
    mutationFn: redeemPoints,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setAmount("");
        setRedeemModal(false);
      }, 1500);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });
  const validateAmount = (amount: any) => {
    if (Number(amount) === 0 || Number(amount) > pointBalance) {
      toast.error("Please enter a valid amount");

      return false;
    }
    if (Number(amount) < 200) {
      toast.error("You can only redeem 200 points above");

      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    if (!validateAmount(amount)) {
      return;
    }

    setAddPin(true);
  };

  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error2 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });
  const getAllOldBanks = async () => {
    const response = await axiosInstance.get(API.getBanksDeex);
    return response.data;
  };

  const { data: allOldBanks, error: error3 } = useQuery({
    queryKey: ["all-old-banks"],
    queryFn: getAllOldBanks,
    retry: 1,
  });

  useEffect(() => {
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error3) {
      const newError = error3 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error2, error3]);

  useEffect(() => {
    if (!isChecked || !bankNumber || !bankName || !amount) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [isChecked, bankNumber, bankName, amount]);

  const makeDefault = async ({ accountNumber, bankCode }: any) => {
    const response = await axiosInstance.put(API.makeDefaultBank(bankId), {
      accountNumber,
      bankCode,
    });
    return response.data;
  };

  const completeMakeDefault = useMutation({
    mutationFn: makeDefault,
    onSuccess: (r) => {
      toast.success(r.message);
      refetch();
      setLoadingIndex(null);
      setTimeout(() => {
        setOpenBank(false);
      }, 1000);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
      setLoadingIndex(null);
    },
  });
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-75  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="flex pt-4 w-full justify-between items-center">
          <h4 className="font-bold font-sora text-[18px] dark:text-white text-paragraph">
            Redeem Points
          </h4>
          <AiOutlineCloseCircle
            onClick={() => setRedeemModal((prev: any) => !prev)}
            className=" text-[24px] text-black dark:text-white cursor-pointer"
          />
        </div>
        <div className="w-full h-[1px] bg-[#AEBCC6] mt-4 dark:bg-[#3A4852]" />
        {addPin ? (
          <div className="mt-12">
            <h4 className="text-gray-900 text-center dark:text-gray-100 font-sora mb-4 font-semibold text-[20px]">
              Enter transaction PIN
            </h4>
            <OtpPin otp={otp} input={4} setOtp={setOtp} />
            <button
              onClick={() => {
                const data = {
                  points: amount,
                  bankDetails: {
                    accountNumber: bankNumber,
                    bankCode: bankCode,
                    accountName: bankName,
                  },
                  pin: otp,
                };
                // console.log(data);
                completeRedeem.mutate(data);
              }}
              disabled={otp.length !== 4}
              className={
                otp.length !== 4
                  ? "mt-44 bg-gray-400 flex justify-center items-center text-gray-200 font-medium w-full h-[52px] rounded-xl"
                  : "mt-44 bg-secondary_button flex justify-center items-center text-white font-medium w-full h-[52px] rounded-xl"
              }
            >
              {completeRedeem.isPending ? (
                <ClipLoader color="#ffffff" size={20} />
              ) : (
                "Proceed"
              )}
            </button>
          </div>
        ) : (
          <div className="mt-6 w-full">
            <label className="text-[14px] text-gray-800 dark:text-gray-300">
              Amount
            </label>
            <input
              type="text"
              value={amount}
              onChange={handleAmountChange}
              placeholder="100 Points"
              className="w-full dark:bg-[#1F2B36] dark:text-[white] dark:border-[#095B97] h-[58px] text-[15px] lgss:text-[16px] text-[#4E606E] placeholder:text-[#4f5d67] mt-2 rounded-xl border border-[#617889] bg-[#F7F8F9] px-4 outline-none"
            />
            <div className="flex mt-3 justify-between items-center">
              {pointBalance && (
                <h4 className="text-center mt-2 text-[13px] font-medium text-gray-700 dark:text-gray-300">
                  Balance:
                  <span className="text-green-700">
                    {formatAmount(pointBalance)}
                  </span>
                </h4>
              )}
              <PortionAmount setAmount={setAmount} coinBalance={pointBalance} />
            </div>
            <h4 className="text-[14px] text-gray-800 mt-6 dark:text-gray-300">
              You will receive
            </h4>
            <div className="w-full dark:bg-[#1F2B36] dark:text-[white] flex justify-start items-center dark:border-[#095B97] h-[58px] text-[15px] lgss:text-[16px] text-[#4E606E] placeholder:text-[#4f5d67] mt-2 rounded-xl border border-[#617889] bg-[#F7F8F9] px-4 outline-none">
              ₦ {Number(amount) * 10}
            </div>
            <div className="mt-8 w-full relative">
              <h4 className="text-[14px] text-gray-800 dark:text-gray-300">
                Select Destination
              </h4>
              <div
                onClick={() => {
                  setOpenBank((prev) => !prev);
                }}
                className="w-full dark:bg-[#1F2B36] dark:text-[white] flex justify-between items-center dark:border-[#095B97] h-[58px] text-[15px] lgss:text-[16px] text-[#4E606E] placeholder:text-[#4f5d67] mt-2 rounded-xl border border-[#617889] bg-[#F7F8F9] px-4 outline-none"
              >
                <div className="flex justify-start items-center gap-3">
                  <h4 className="text-[14px] text-gray-700 dark:text-gray-300">
                    {bankNumber} - {bankName}
                  </h4>
                </div>
                <RiArrowDropDownFill className="text-[28px] text-gray-700 dark:text-gray-300" />
              </div>
              {openBank && (
                <div className="absolute z-50 rounded-xl w-full mt-2 p-3 h-[250px] border border-gray-200 dark:border-gray-600 dark:bg-gray-800 overflow-auto bg-white">
                  {userDetails?.user?.banks.length >= 1 ? (
                    <div className="w-full">
                      {userDetails.user.banks
                        .sort((a: any, b: any) => b.isDefault - a.isDefault)
                        .map((bank: any, index: number) => {
                          const matchedBank =
                            allBanks?.data.find(
                              (allBank: any) =>
                                allBank.bankCode === bank.bankCode
                            ) ||
                            allOldBanks?.data.find(
                              (newBank: any) => newBank.code === bank.bankCode
                            );

                          return (
                            <div
                              key={index}
                              onClick={() => {
                                if (bank.isDefault) {
                                  setBankNumber(bank.accountNumber);
                                  setBankName(
                                    matchedBank?.bankName || matchedBank?.name
                                  );
                                  setBankCode(bank.bankCode);
                                  setOpenBank(false);
                                } else {
                                  setBankId(bank._id);
                                  setLoadingIndex(index);
                                  setTimeout(() => {
                                    completeMakeDefault.mutate({
                                      accountNumber: bank.accountNumber,
                                      bankCode: bank.bankCode,
                                    });
                                    setBankNumber(bank.accountNumber);
                                    setBankName(
                                      matchedBank?.bankName || matchedBank?.name
                                    );
                                  }, 500);
                                }
                              }}
                              className={`w-full cursor-pointer flex justify-start items-center gap-4 p-4 ${
                                bank.isDefault
                                  ? "border border-secondary_button rounded-xl"
                                  : "border-b border-gray-200 dark:border-gray-600"
                              }`}
                            >
                              {loadingIndex === index ? (
                                <ClipLoader color="#5E91FF" size={20} />
                              ) : (
                                <div
                                  className={`w-[20px] h-[20px] p-1 flex justify-center items-center rounded-full border ${
                                    bank.isDefault
                                      ? "border-secondary_button"
                                      : "bg-transparent border-[#505050]"
                                  }`}
                                >
                                  <div
                                    className={`w-full h-full rounded-full ${
                                      bank.isDefault
                                        ? "bg-secondary_button"
                                        : "bg-transparent"
                                    }`}
                                  />
                                </div>
                              )}
                              <div>
                                <h4 className="text-[10px] font-bold text-gray-700 dark:text-gray-200">
                                  {bank.accountName}
                                </h4>
                                <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
                                  {bank.accountNumber} -{" "}
                                  {matchedBank?.bankName ||
                                    matchedBank?.name ||
                                    "Unknown Bank"}
                                </h4>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <button
                      onClick={() => navigate("/settings")}
                      className="p-3 text-[14px] mt-8 mds:mt-0 transition ease-out duration-300 rounded-xl bg-secondary_button text-white gap-4 flex justify-center items-center"
                    >
                      <h4>Add bank</h4>
                      <BiMessageSquareAdd className="text-2xl" />
                    </button>
                  )}
                </div>
              )}
            </div>
            <div className="mt-10">
              <div className="flex  justify-start mt-6 w-full items-start gap-4">
                <div>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    className="h-[24px] w-[24px]"
                  />
                </div>
                <div className="font-medium text-[#617889] dark:text-gray-300 text-[14px]">
                  I hereby confirm that i want to convert {amount} points to ₦
                  {Number(amount) * 10} (at ₦10 per point). Funds from
                  conversion will be approved and sent to my Deex wallet
                  immediately.
                </div>
              </div>
            </div>

            <button
              onClick={handleSubmit}
              disabled={disabled}
              className={
                disabled
                  ? "h-[60px] w-full mx-auto flex rounded-lg mt-12 items-center justify-center bg-[#AEBCC6] text-white dark:bg-gray-600"
                  : "h-[60px] w-full mx-auto flex rounded-lg mt-12 items-center justify-center bg-secondary_button text-white"
              }
            >
              {completeRedeem.isPending ? (
                <ClipLoader color="#FFFFFF" size={25} />
              ) : (
                "Redeem and Withdraw"
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RedeemModal;
